const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  generateOauth2UrlLogin ({ state, commit, rootState }, params) {
    return rootState.axios.get('/push/v1frontend/line-login/generate-oauth2-url-login', { params })
  },
  generateOauth2UrlBind ({ state, commit, rootState }, params) {
    return rootState.axios.get('/push/v1frontend/line-login/generate-oauth2-url-bind', { params })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
